//Basic Card
export const BASIC_CARD = [
  {
    text: "This is a simple basic card using anywhere.",
  },
];

//Flat Cards
export const FLAT_CARD = [
  {
    text: "For flat cards, make the",
    code: ".b-r-0[border-radius:0]",
  },
  {
    text: "used class.",
  },
];

//Without Shadow Cards
export const WITHOUT_SHADOW_CARD = [
  {
    text: "Use the",
    code: ".shadow-none ",
  },
  {
    text: "&",
    code: ".border ",
  },
  {
    text: "class through shadow removes.",
  },
];

//Icon In Headings
export const ICON_IN_HEADINGS = [
  {
    text: "Use the any icons  for heading. ",
    code: "[font-awesome/ico-font/feather].",
  },
];

//Dark Color Cards
export const DARK_COLOR_CARD = [
  {
    text: "Use the",
    code: ".bg-dark ",
  },
  {
    text: "color for dark background card.",
  },
];

//Info Color Header
export const INFO_COLOR_HEADER = [
  {
    headerClass: "bg-info",
    headingClass: "text-white",
    title: "Info Color Header",
    text: "Web Designer",
    span: "By following instructions and adding your own unique twist and style, you may apply your imagination as a web designer. The majority of the tasks you'll be assigned will have a specific due date and work description, but the reason you were employed was because they need a specialist to inject some much-needed creativity.",
  }
];

//Info ColorBody
export const INFO_COLOR_BODY = [
  {
    bodyClass: "bg-info",
    title: "Info Color Body",
    text: "UX Designer",
    span: 'It is the responsibility of the UX designer to make a product or service useful, pleasurable, and accessible. The word "user experience" is used by various industries, although it is most frequently related to digital design for websites and mobile applications.There is no need for coding in user experience design.',
  }
];

//Info ColorFooter
export const INFO_COLOR_FOOTER = [
  {
    bodyClass: "mb-4",
    sm: "12",
    title: "Info Color Footer",
    text: "Web Developer",
    span: "A programmer who uses the client-server architecture to create World Wide Web applications is known as a web developer. The apps generally employ any general-purpose programming language on the server and HTML, CSS, and JavaScript on the client.",
    footerClass:"bg-info"
  }
];